import { Column } from 'primereact/column'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  Btn,
  CustomCardColorBar,
  CustomDropdown,
  PageHeader,
  SectionTitle,
  TextBtn,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { DataTable } from 'primereact/datatable'
import { tableCellCentered } from '../../../../assets/js/styles'
import { Panel } from 'primereact/panel'
import useDevolucoesPendentesTPs, { FIELDS_NAME, LOAD_MESSAGE } from './DevolucoesPendentesHook'
import ModalDataTable from '../../../../components/ModalDataTable/ModalDataTable'
import * as colors from '../../../../assets/js/colors'
import CustomPieChart from '../../../../components/CustomPieChart/CustomPieChart'
import CustomHorizontalBarChart from '../../../../components/CustomHorizontalBarChart/CustomHorizontalBarChart'

function DevolucoesPendentesTPs({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useDevolucoesPendentesTPs()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_INIT_INFO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getCompaniesGroupAssociatedToUser()
        break

      case LOAD_MESSAGE.GET_DASHBOARD_INFO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getDevolucoesPendentesTps(state.companyGroupSelected, selectedTp)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    localDispatch.onInit()
  }, [selectedTp])

  return (
    <>
      <PageHeader>1.4 - Devoluções Pendentes TPs</PageHeader>
      <div style={{ marginTop: 16 }}>
        <Panel header={<TextBtn onClick={history.goBack}>Voltar</TextBtn>}>
          <div className="p-grid p-justify-center">
            <div className="p-grid p-col-12">
              <div className="p-md-4 p-col-12">
                <CustomDropdown
                  showLabel={true}
                  label="Grupo de Empresas"
                  optionLabel={'label'}
                  marginTop={10}
                  options={state.companiesGroups}
                  value={state.companyGroupSelected}
                  onChange={localDispatch.onCompanyGroupChange}
                />
              </div>
              <div className="p-md-fixed">
                <div style={{ marginLeft: 10, paddingTop: 35 }}>
                  <Btn onClick={() => localDispatch.onBtnPesquisar(state.companyGroupSelected)}>
                    Pesquisar
                  </Btn>
                </div>
              </div>
            </div>
            <div className="p-col-12 p-grid">
              <div className="p-col-12">
                <SectionTitle title={'Dados das Devoluções Pendentes'} />
              </div>
              <div className="p-col-12 p-md-4">
                <CustomCardColorBar
                  value={state.dashboardInfo.total_caixas}
                  title={'Total de Caixas para Devolução'}
                  subTitle={`em cx`}
                  barColor={colors.error}
                />
              </div>
              <div className="p-col-12 p-md-4">
                <CustomCardColorBar
                  value={state.dashboardInfo.total_entregas}
                  title={'Total de Devoluções'}
                  subTitle={`em qtd entrega`}
                  barColor={colors.laranja}
                />
              </div>
              <div className="p-col-12 p-md-4">
                <CustomCardColorBar
                  value={state.dashboardInfo.total_entregas_sem_senha}
                  title={'Total de Devoluções sem Senha'}
                  subTitle={`em qtd entrega`}
                  barColor={colors.vermelho}
                />
              </div>
              <div className="p-col-12 p-md-6">
                <CustomHorizontalBarChart
                  title={'Devoluções em Qtd de Entregas'}
                  items={state.dashboardInfo.graph_data.devolucoes_totais_parcias}
                  borderTopColor={colors.azul}
                  label={'value'}
                />
              </div>
              <div className="p-col-12 p-md-6">
                <CustomPieChart
                  title={'Status de Ordem de Coleta'}
                  items={state.dashboardInfo.graph_data.status_ordem_coleta}
                  cellColors={state.cellColors}
                  borderTopColor={colors.azul_escuro}
                />
              </div>
            </div>
            <div className="p-grid p-col-12">
              <DataTable
                value={state.dashboardInfo.devolucoes_pendentes}
                style={{
                  textAlign:
                    state.dashboardInfo.devolucoes_pendentes.length > 0 ? 'inherit' : 'center',
                }}
                emptyMessage="Não existem dados para serem exibidos"
                responsive
              >
                <Column field="tp_name" header="Operação" style={tableCellCentered()} />
                <Column field="qte_caixas" header="Qte. Caixas" style={tableCellCentered(60)} />
                <Column
                  field={FIELDS_NAME.DEVOLUCOES_COM_ORDEM}
                  header="Devoluções com Ordem"
                  body={data => (
                    <TextBtn
                      onClick={() =>
                        localDispatch.onClickOpenModal(FIELDS_NAME.DEVOLUCOES_COM_ORDEM, data)
                      }
                      color={colors.azul_escuro}
                    >
                      {data.devolucoes_com_ordem}
                    </TextBtn>
                  )}
                  style={tableCellCentered(50)}
                />
                <Column
                  field={FIELDS_NAME.DEVOLUCOES_SEM_ORDEM}
                  header="Devoluções sem Ordem"
                  body={data => (
                    <TextBtn
                      onClick={() =>
                        localDispatch.onClickOpenModal(FIELDS_NAME.DEVOLUCOES_SEM_ORDEM, data)
                      }
                      color={colors.azul_escuro}
                    >
                      {data.devolucoes_sem_ordem}
                    </TextBtn>
                  )}
                  style={tableCellCentered(50)}
                />
                <Column
                  field={FIELDS_NAME.DEVOLUCOES_SEM_SENHA}
                  header="Devoluções sem Senha"
                  body={data => (
                    <TextBtn
                      onClick={() =>
                        localDispatch.onClickOpenModal(FIELDS_NAME.DEVOLUCOES_SEM_SENHA, data)
                      }
                      color={colors.azul_escuro}
                    >
                      {data.devolucoes_sem_senha}
                    </TextBtn>
                  )}
                  style={tableCellCentered(50)}
                />
                <Column
                  field="maximo_atraso"
                  header="Maior Tempo de Atraso em Dias"
                  style={tableCellCentered(50)}
                />
              </DataTable>
            </div>
          </div>
        </Panel>
        <ModalDataTable
          fields={state.modalInfo.fields}
          data={state.modalInfo.data}
          onClose={localDispatch.onModalClose}
          title={state.modalInfo.title}
          show={state.modalInfo.show}
          width={state.modalInfo.width}
          fieldParser={state.modalInfo.fieldParser}
          expander={state.modalInfo.expander}
          expanderTemplate={state.modalInfo.expanderTemplate}
          rowExpansionTemplate={rowExpansionTemplate}
          expanderDataKey={'identificador'}
          expanderTemplateColumn={'cliente'}
          exportButton={true}
          exportFileName={state.modalInfo.exportFileName}
        />
      </div>
    </>
  )
}

const rowExpansionTemplate = data => {
  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12 p-md-9">
        <div className="p-grid">
          <div className="p-md-2">Nome: </div>
          <div className="p-md-4" style={{ fontWeight: 'bold' }}>
            {data.cliente}
          </div>

          <div className="p-md-2">Cidade: </div>
          <div className="p-md-4" style={{ fontWeight: 'bold' }}>
            {data.cidade}
          </div>

          <div className="p-md-2">Bairro: </div>
          <div className="p-md-4" style={{ fontWeight: 'bold' }}>
            {data.bairro}
          </div>

          <div className="p-md-2">CNPJ: </div>
          <div className="p-md-4" style={{ fontWeight: 'bold' }}>
            {data.cnpj}
          </div>
          <div className="p-md-3" style={{ display: data.ordem_name ? 'block' : 'none' }}>
            Ordem de Coleta:{' '}
          </div>
          <div
            className="p-md-3"
            style={{ fontWeight: 'bold', display: data.ordem_name ? 'block' : 'none' }}
          >
            {data.ordem_name}
          </div>
          <div className="p-md-3" style={{ display: data.ordem_data ? 'block' : 'none' }}>
            Data da Ordem:{' '}
          </div>
          <div
            className="p-md-3"
            style={{ fontWeight: 'bold', display: data.ordem_data ? 'block' : 'none' }}
          >
            {data.ordem_data}
          </div>
          <div className="p-md-2">Qte. Caixas: </div>
          <div className="p-md-10" style={{ fontWeight: 'bold' }}>
            {data.qte_caixas}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapToProps = ({
  dashboard: {
    statusOperacoes: { status, pInicial, pFinal },
  },
  system: { selectedTp },
}) => ({ status, pInicial, pFinal, selectedTp })
export default connect(mapToProps)(withRouter(DevolucoesPendentesTPs))
